import { computed, makeObservable } from 'mobx'

import { ISitePermitInspectionChange } from '~/client/graph'
import PermitInspectionChange from '~/client/src/shared/models/PermitInspectionChange'
import EventsStore from '~/client/src/shared/stores/EventStore/Events.store'

export default class PermitInspectionChangesStore {
  public constructor(private eventsStore: EventsStore) {
    makeObservable(this)
  }

  @computed
  public get list() {
    return Array.from(this.byId.values())
  }

  public get byId() {
    return this.eventsStore.appState.permitInspectionChanges
  }

  public clearList() {
    this.byId.clear()
  }

  public receiveList(list: ISitePermitInspectionChange[]) {
    this.clearList()
    this.updateFromList(list)
  }

  public updateFromList(list: ISitePermitInspectionChange[]) {
    list.forEach(dto => this.receiveOne(dto.id, dto))
  }

  public receiveOne(id: string, dto: ISitePermitInspectionChange) {
    if (dto) {
      const inspectionChange = PermitInspectionChange.fromDto(dto)
      this.byId.set(inspectionChange.id, inspectionChange)
    } else {
      this.byId.delete(id)
    }
  }

  public getChangesForInspections = (inspectionIds: string[]) => {
    return this.list
      .filter(sc => inspectionIds.includes(sc.inspectionId))
      .sort((a, b) => a.createdAt - b.createdAt)
  }

  @computed
  private get latestByInspectionId(): Map<string, PermitInspectionChange> {
    const map = new Map<string, PermitInspectionChange>()
    for (const change of this.list) {
      const existing = map.get(change.inspectionId)
      if (!existing || change.createdAt > existing.createdAt) {
        map.set(change.inspectionId, change)
      }
    }
    return map
  }

  public getLatestChangeForInspection = (inspectionId: string) => {
    return this.latestByInspectionId.get(inspectionId)
  }
}
